import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { environment } from '@goalmate/environment';

@Component({
  selector: 'goalmate-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
})
export class NavbarComponent {
  private document = inject(DOCUMENT);
  private analytics = inject(Analytics);

  onLogin() {
    logEvent(this.analytics, 'web_login_click');
    const window = this.document.defaultView;
    if (!window?.location) return;
    window.location.href = environment.host.app;
  }

  onSignup() {
    logEvent(this.analytics, 'web_signup_click');
    const window = this.document.defaultView;
    if (!window?.location) return;
    window.location.href = environment.host.app + '/auth/signup';
  }
}
